"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileInputField = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var FileIconLarge_1 = __importDefault(require("./FileIconLarge"));
var format_1 = require("../../app/util/format");
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a;
    return (0, core_1.createStyles)({
        fileInputWrapper: {
            width: '100%',
            display: 'flex',
            alignItems: 'stretch',
            borderRadius: '3px',
            overflow: 'hidden',
            border: function (props) {
                return props.uploadFileError ? '2px solid #C85151' : '';
            },
        },
        fileNameText: {
            fontWeight: 400,
            paddingLeft: '16px',
            display: 'flex',
            alignItems: 'center',
        },
        fileInputInvis: {
            display: 'none',
        },
        leftFileIcon: {
            width: '44px',
            backgroundColor: theme.palette.primary.main,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        fileInput: (_a = {
                flexGrow: 1,
                height: '100%',
                minHeight: function (props) { return props.textFieldHeight; },
                padding: theme.spacing(0),
                lineHeight: 1.5,
                backgroundColor: theme.palette.divider,
                display: 'flex',
                alignItems: 'stretch',
                overflow: 'hidden',
                justifyContent: 'space-between',
                borderRadius: '3px'
            },
            _a[theme.breakpoints.up('sm')] = {
                backgroundColor: '#e8e8e8',
            },
            _a),
        fileSizeText: {
            fontWeight: 400,
            display: 'flex',
            alignItems: 'center',
            paddingRight: theme.spacing(1.5),
        },
        fileInputEndWrapper: {
            display: 'flex',
            alignItems: 'stretch',
        },
        uploadButtonText: {
            padding: 0,
            margin: 0,
            width: '120px',
            height: '100%',
            borderRadius: 0,
            color: theme.palette.background.default,
        },
    });
});
var FileInputField = function (_a) {
    var textFieldHeight = _a.textFieldHeight, _b = _a.fileNameText, fileNameText = _b === void 0 ? '' : _b, _c = _a.fileSizeText, fileSizeText = _c === void 0 ? '' : _c, _d = _a.buttonText, buttonText = _d === void 0 ? '' : _d, setFile = _a.setFile, uploadFileError = _a.uploadFileError, setUploadFileError = _a.setUploadFileError, _e = _a.isUploading, isUploading = _e === void 0 ? false : _e, className = _a.className, _f = _a.acceptedTypes, acceptedTypes = _f === void 0 ? '' : _f, maxSize = _a.maxSize;
    var theme = (0, core_1.useTheme)();
    var classes = useStyles({ textFieldHeight: textFieldHeight, uploadFileError: uploadFileError });
    return (react_1.default.createElement("div", { className: "".concat(classes.fileInputWrapper, " ").concat(className) },
        react_1.default.createElement(core_1.Hidden, { smDown: true },
            react_1.default.createElement("div", { className: classes.leftFileIcon },
                react_1.default.createElement(FileIconLarge_1.default, { color: theme.palette.background.default }))),
        react_1.default.createElement("div", { className: classes.fileInput },
            react_1.default.createElement(core_1.Typography, { variant: "body2", className: classes.fileNameText }, fileNameText),
            react_1.default.createElement("input", { type: "file", id: "file", className: classes.fileInputInvis, onChange: function (event) {
                    if (!event.target.files) {
                        return;
                    }
                    var chosenFile = event.target.files[0];
                    if (!chosenFile) {
                        return;
                    }
                    if (chosenFile.size > maxSize) {
                        setFile(null);
                        setUploadFileError("File too large, please upload a file smaller than ".concat((0, format_1.formatBytes)(maxSize)));
                        return;
                    }
                    setUploadFileError('');
                    setFile(chosenFile);
                    // Clear value so that file event is refired when even if same file is uploaded https://stackoverflow.com/a/60886920
                    // eslint-disable-next-line no-param-reassign
                    event.target.value = '';
                }, accept: acceptedTypes }),
            react_1.default.createElement(core_1.Typography, { variant: "body2", className: classes.fileSizeText }, fileSizeText)),
        react_1.default.createElement("div", { className: classes.fileInputEndWrapper },
            react_1.default.createElement("label", { htmlFor: "file" },
                react_1.default.createElement(core_1.Button, { variant: "contained", className: classes.uploadButtonText, component: "span", color: "primary", disabled: isUploading }, isUploading ? (react_1.default.createElement(core_1.CircularProgress, { color: "primary", size: 20 })) : (buttonText))))));
};
exports.FileInputField = FileInputField;
exports.default = exports.FileInputField;
